var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3.5H5C3.9 3.5 3 4.4 3 5.5V19.5C3 20.6 3.9 21.5 5 21.5H19C20.1 21.5 21 20.6 21 19.5V5.5C21 4.4 20.1 3.5 19 3.5ZM8 17.5C7.45 17.5 7 17.05 7 16.5V11.5C7 10.95 7.45 10.5 8 10.5C8.55 10.5 9 10.95 9 11.5V16.5C9 17.05 8.55 17.5 8 17.5ZM12 17.5C11.45 17.5 11 17.05 11 16.5V8.5C11 7.95 11.45 7.5 12 7.5C12.55 7.5 13 7.95 13 8.5V16.5C13 17.05 12.55 17.5 12 17.5ZM16 17.5C15.45 17.5 15 17.05 15 16.5V14.5C15 13.95 15.45 13.5 16 13.5C16.55 13.5 17 13.95 17 14.5V16.5C17 17.05 16.55 17.5 16 17.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.e00c08a630c8706baa340bcef44963c1.svg";
export { ForwardRef as ReactComponent };